const MASK_MARKERS = /\.{3}|•{3,}|\*{3,}/;

export const maskApiKeyForList = (
  value: string | null | undefined,
): string | null => {
  const normalized = value?.trim();
  if (!normalized) return null;

  const prefix = normalized.toLowerCase().startsWith("sk-") ? "sk-" : "";
  const valueWithoutPrefix = prefix ? normalized.slice(prefix.length) : normalized;
  const isAlreadyMasked = MASK_MARKERS.test(valueWithoutPrefix);

  if (!isAlreadyMasked && valueWithoutPrefix.length <= 4) {
    return `${prefix}••••`;
  }

  const maskedParts = valueWithoutPrefix.split(MASK_MARKERS);
  const suffixSource = isAlreadyMasked
    ? maskedParts[maskedParts.length - 1] ?? ""
    : valueWithoutPrefix;
  const suffix = suffixSource.slice(-4);

  if (suffix.length < 4) return `${prefix}••••`;
  return `${prefix}...${suffix}`;
};
